"use strict";

var LoggerInstance = require("js-logger").get("OneTimePassword");

var OneTimePasswordApi = require("../api/OneTimePasswordApi");

var Spinner = require("../client/Spinner");

var StringConstants = require("../constants/StringConstants");

var Constants = require("../designer/Constants");
const BootstrapPrompt = require("../shared/BootstrapPrompt");

var oneTimePasswordCancelSelector = ".one-time-password-abort";
var oneTimePasswordSubmitSelector = ".one-time-password-submit";
var oneTimePasswordResendSelector = "[data-dynamic-href='resendCode']";

var OneTimePasswordHelper = {
	initialize: function (type) {
		if (!type) {
			LoggerInstance.error("A 'type' must be provided.");
			return;
		}
		if (type == StringConstants.OneTimePasswordTypes.GuestCheckout) {
			this.isOneTimePasswordRequired = window.CheckoutActions.getOneTimePasswordRequired();
			this.oneTimePasswordType = type;
			this.oneTimePasswordMessagesWizard = window.CheckoutActions.getOneTimePasswordForGuestCheckoutMessages();
			this.oneTimePasswordPopupSelector = "[data-component='oneTimePasswordForGuestCheckout']";
			this.oneTimePasswordVerificationCodeInputSelector = "[data-component='oneTimePasswordForGuestCheckout.input']";
		} else if (type == StringConstants.OneTimePasswordTypes.CreateAccount) {
			this.isOneTimePasswordRequired = window.AccountActions.getOneTimePasswordRequired();
			this.oneTimePasswordType = type;
			this.oneTimePasswordMessagesWizard = window.AccountActions.getOneTimePasswordForCreateAccountMessages();
			this.oneTimePasswordPopupSelector = "[data-component='oneTimePasswordForCreateAccount']";
			this.oneTimePasswordVerificationCodeInputSelector = "[data-component='oneTimePasswordForCreateAccount.input']";
		}

		this.isResending = false;
		var themeId = $("#createAccountForm").attr("data-theme") || $("body").attr("data-theme");

		if (($("#createAccountForm").length || (window.grecaptcha && window.grecaptcha.enterprise)) && themeId) {
			OneTimePasswordApi.getOneTimePasswordHtml(themeId, type).done((data) => {
				if (data.success) {
					// Just got the Popup and OTP Generate html
					this.oneTimePasswordModalHtml = data.model.oneTimePasswordHtml;

					this.initialized = true;
				}
			});
		}
	},

	showOneTimePasswordModal(deferred) {
		var html = $(this.oneTimePasswordModalHtml);
		var $popup = $(html).hide().appendTo("body");
		this.popup = $popup;
		this.isResending = false;

		$popup.find(this.oneTimePasswordPopupSelector).addBack(this.oneTimePasswordPopupSelector).css({
			left: `calc(50% - ${($popup.width() / 2)}px)`,
			top: "25%",
			position: "fixed"
		});

		$popup.show();

		//Adding Click Events
		$popup.find(oneTimePasswordCancelSelector).click(() => {
			//Constituent wants to go back and correct or ignore.
			this._removePopup($popup);
			deferred.reject();
		});

		$popup.find(oneTimePasswordSubmitSelector).click(() => {
			//Constituent wants to verify the email.
			Spinner.showSpinner($popup);
			var oneTimePassword = $(this.oneTimePasswordVerificationCodeInputSelector).val();
			if (!oneTimePassword) {
				Spinner.removeSpinner($popup);
				BootstrapPrompt.alert(this.oneTimePasswordMessagesWizard.invalidOneTimePassword);
			} else {
				this._removePopup($popup);
				deferred.resolve(oneTimePassword);
			}
		});

		$popup.find(oneTimePasswordResendSelector).click((event) => {
			event.preventDefault();
			//Constituent wants to resend the email.
			try {
				if (this.isResending) {
					return;
				} else {
					Spinner.showSpinner($popup);
					this.isResending = true;
				}

				this.verifyOneTimePassword(deferred);
			} catch (e) {
				BootstrapPrompt.alert(this.oneTimePasswordMessagesWizard.unableToGenerateOneTimePassword);
			};
		});

		$popup.find("[data-component='help']").off("click.pinModal").on("click.pinModal", function (event) {
			window.showPinModal();
		});

		//Escape linked to go back.
		$(document).on("keydown", { $popup }, this._popupEscapeHandler);
	},

	_handleGeneratePasswordError(jqXHR, textStatus, errorThrown) {
		Spinner.removeSpinner(this.popup);
		BootstrapPrompt.alert(this.oneTimePasswordMessagesWizard.unableToGenerateOneTimePassword);
		LoggerInstance.error(`Unable to generate the One-Time Password.`);
	},

	verifyOneTimePassword: function (deferred) {
		deferred = deferred || new $.Deferred();

		this.verifying = true;
		var $emailAddressElement = $("#createAccountForm input[data-component='accountEmailAddress']");
		var emailAddress = $emailAddressElement.val();

		if ((!this.isResending || $emailAddressElement.length) && !emailAddress) {
			BootstrapPrompt.alert(this.oneTimePasswordMessagesWizard.missingEmailAddress);
			deferred.reject();
			return deferred;
		}

		OneTimePasswordApi.generateOneTimePassword({
			email: emailAddress,
			type: this.oneTimePasswordType
		}).done((response) => {
			this.generatingOneTimePassword = false;

			if (this.isResending) {
				Spinner.removeSpinner(this.popup);
				BootstrapPrompt.success(this.oneTimePasswordMessagesWizard.oneTimePasswordResent);
				this.isResending = false;
			} else {
				this.showOneTimePasswordModal(deferred);
			}
		}).fail((jqXHR, textStatus, errorThrown) => {
			this.generatingOneTimePassword = false;
			this._handleGeneratePasswordError(jqXHR, textStatus, errorThrown);
			deferred.reject();
		});

		return deferred;
	},

	_popupEscapeHandler(event) {
		if (!event || !event.data) {
			LoggerInstance.error("Event or Event Data not present in Popup Escape Handler");
			return;
		}

		// A dialog opened on top of the popup owns the keyboard: the Help PIN modal, or any BootstrapPrompt alert.
		if ($(".bootstrap-dialog.in").length) {
			return;
		}

		switch (event.which) {
			case Constants.KEYS.ESCAPE:
				$(event.data.$popup).find(oneTimePasswordCancelSelector).click();
				break;
		}
	},

	_removePopup($popup) {
		$(document).off("keydown", this._popupEscapeHandler);
		$popup.remove();
	}
};

module.exports = OneTimePasswordHelper;
